/*
 * @Description: 订单筛选模块
 * @Author: hujingyang
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Balloon, Button, Cascader, DatePicker, Dialog, Form, Icon, Input, Message, Notification, NumberPicker, Select, Tab, Table } from '@alifd/next';
import style from './index.module.scss';
import ParagraphTitle from '@/components/ParagraphTitle';
import LzPagination from '@/components/common/LzPagination';
import moment from 'moment';
import { Servlets } from '@/service';
import { appHistory } from '@ice/stark-app';
import utils from '@/common/utils';
import { store } from '@ice/stark-data';
import LzMessage from '@/components/common/LzMessage';
import LzMsg from '@/components/common/LzMsg'

const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { Tooltip } = Balloon;
const orderStatusDiscAll = {
  1: {
    name: '待支付',
  },
  2: {
    name: '备货中',
  },
  3: {
    name: '已发货',
  },
  4: {
    name: '已取消',
  },
  5: {
    name: '已完成',
  },
  6: {
    name: '退货中-用户申请',
  },
  7: {
    name: '退货中-商家同意退货',
  },
  8: {
    name: '退货中-客服仲裁',
  },
  9: {
    name: '已关闭-退货失败',
  },
  10: {
    name: '退货中-客服同意',
  },
  11: {
    name: '退货中-用户已填物流',
  },
  12: {
    name: '退货成功-商户同意',
  },
  13: {
    name: '退货中-再次客服仲裁',
  },
  14: {
    name: '退货中-客服同意退款',
  },
  15: {
    name: '退货-用户取消',
  },
  16: {
    name: '退款中-用户申请(备货中)',
  },
  17: {
    name: '退款中-商家同意(备货中)',
  },
  21: {
    name: '退款成功-订单退款（备货中，用户申请退款，最终退款成功）',
  },
  22: {
    name: '退款成功-订单退款 (已发货时，用户申请退货，最终退货退款成功)',
  },
  24: {
    name: '退货成功-商户已退款 (特指货到付款订单，已发货时，用户申请退货，最终退货退款成功)',
  },
  25: {
    name: '退款中-用户取消(备货中)',
  },
  26: {
    name: '退款中-商家拒绝（备货中）',
  },
  27: {
    name: '退货中-等待买家处理（已发货，商家拒绝用户退货申请）',
  },
  28: {
    name: '退货中-等待买家处理（已发货，商家拒绝用户退货申请）',
  },
  29: {
    name: '退货中-等待买家处理（已发货，用户填写退货物流，商家拒绝）',
  },
  30: {
    name: '退款中-退款申请（已发货，用户申请仅退款）',
  },
  31: {
    name: '退款申请取消（已发货，用户申请仅退款时，取消申请）',
  },
  32: {
    name: '退款中-商家同意（已发货，用户申请仅退款，商家同意申请）',
  },
  33: {
    name: '退款中-商家拒绝（已发货，用户申请仅退款，商家拒绝申请）',
  },
  34: {
    name: '退款中-客服仲裁（已发货，用户申请仅退款，商家拒绝申请，买家申请客服仲裁）',
  },
  35: {
    name: '退款中-客服同意（已发货，用户申请仅退款，商家拒绝申请，客服仲裁支持买家）',
  },
  36: {
    name: '退款中-支持商家（已发货，用户申请仅退款，商家拒绝申请，客服仲裁支持商家）',
  },
  37: {
    name: '已关闭-退款失败（已发货，用户申请仅退款时，退款关闭）',
  },
  38: {
    name: '退款成功-售后退款（特指货到付款订单，已发货，用户申请仅退款时，最终退款成功）',
  },
  39: {
    name: '退款成功-订单退款（已发货，用户申请仅退款时，最终退款成功）',
  },
  101: {
    name: '部分发货',
  },
  105: {
    name: '已支付',
  },
};

/** 订单筛选模块 */
const Tabs_orderSelection = (props: any): JSX.Element => {
  // 提示弹窗
  const tips = (type, content, title) => {
    Notification.open({
      title,
      content,
      type,
    });
  };

  const [isLoadingForList, setLoadingForList] = useState(false);// 是否正在加载列表数据
  const [searchFormData, setSearchFormData] = useState({
    cityName: "",
    endCompletTime: "",
    endCreateTime: moment().endOf('day'),
    endPayTime: "",
    orderStatus:0,
    pageNo: 1,
    pageSize: 10,
    startCompletTime: "",
    startCreateTime: moment().subtract(30, 'days').startOf('day'),
    startPayTime: "",
  });// 搜索表单数据集合
  const [dataSource, setDataSource] = useState([] as object[]);// 列表数据
  const [columns, setColumns] = useState([{}]);// 列表title
  const [isShowAllSearchForm, setIsShowAllSearchForm] = useState(false);// 是否展示所有搜索表单项
  const [orderStatusDisc, setOrderStatusDisc] = useState([{ value: '', label: '' }]);// 订单状态字典
  // const [flagColorsDisc, setFlagColorsDisc] = useState([{ value: "", label: "" },]);//旗帜颜色字典
  // const [orderTypeDisc, setOrderTypeDisc] = useState([{ value: "", label: "" },]);//订单类型字典
  // const [APPSourceDisc, setAPPSourceDisc] = useState([{ value: "", label: "" },]);//APP来源字典
  // const [orderSourceDisc, setOrderSourceDisc] = useState([{ value: "", label: "" },]);//订单来源字典
  const [selectedKeysList, setSelectedKeysList] = useState([]);// 当前已选的列表项id
  // const [openDiglog, setOpenDiglog] = useState(false);//是否打开短消息弹窗--新建订单筛选营销任务
  const [currentTabKey, setCurrentTabKey] = useState(0);// 当前tab
  // 分页数据
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 });
  const [receivingAreaValue, setReceivingAreaValue] = useState([] as string[]);// 已选的收货地区 value
  const [receivingAreaName, setReceivingAreaName] = useState([] as string[]);// 已选的收货地区 name 传给后端用
  const [receivingAreaDataDisc, setReceivingAreaDataDisc] = useState([]);// 全部收货地区字典
  // 批量保存人群包dialog显示
  const [crowdDialog, setCrowdDialog] = useState(false);
  const [refreshParams, setRefreshParams] = useState({
    description: `${moment().format('MM月DD日')}创建人群`,
    name: `默认创建${moment().format('MM月DD日HH时mm分ss秒')}`,
  });

  // 复制人群pin上传人群
  const saveCrowd = () => {
    if (!selectedKeysList.length) {
      Message.notice('你还没有选择订单，请选择至少一个订单后操作');
    } else {
      setCrowdDialog(true);
    }
  };
  const packageRefreshSubmit = () => {
    const phone = [];
    dataSource.forEach((item) => {
      // 由于手机号作为全选列的key，会导致当页如果含有同一人的多个订单，就一起被选中了，所以key用订单id，通过这个订单id去匹配手机号
      if (~selectedKeysList.indexOf(item.orderId)) {
        if (!~phone.indexOf(item.postTel)) { // 对phone去重，如果数组里已经有了，就不放进去了
          phone.push(item.postTel);
        }
      }
    });
    Servlets('savePhoneAsCrowd', { ...refreshParams, size: selectedKeysList.length, phones: phone }).then((res) => {
      if(!res.success){
        tips('error', res.resp_msg, '失败');
      }else {
        tips('success', '保存人群包成功', '成功');
        setSelectedKeysList([]);
        setRefreshParams({
          description: ``,
          name: `默认创建${moment().format('MM月DD日HH时mm分ss秒')}`,
        });
        setCrowdDialog(false);
      }

    });
  };

  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    getDiscData();
    getListData({pageNo: pageInfo.pageNo, pageSize: pageInfo.pageSize, startCreateTime: searchFormData.startCreateTime.valueOf(), endCreateTime: searchFormData.endCreateTime.valueOf()});
    setColumns(getColumns());
    setSearchFormDataInit();
  };
  /** 设置搜索表单初始化 */
  const setSearchFormDataInit = (): void => {
    setSearchFormData({ orderStatus: 0, startCreateTime: moment().subtract(30, 'days').startOf('day'), endCreateTime: moment().endOf('day') });
    setCurrentTabKey(0);
  };
  /** 获取数据字典数据 */
  const getDiscData = (): void => {
    // 订单状态字典
    const getOrderStatusDisc = [
      { value: 0, label: '全部订单',label1: '全部订单'  },
      { value: 1, label:'待支付订单',
        label1:
          <div>
            待支付订单
          <Tooltip
              align="t"
              trigger={
                <span
                  style={{
                    fontSize: '16px',
                    marginLeft: '4px',
                    cursor: 'pointer',
                  }}
                  className="iconfont icon-icon4-33"
                />
              }
            >
              在线支付订单待支付；货到付款订单待确认
          </Tooltip>
          </div>
      },
      { value: 2, label: '备货中',label1: '备货中' },
      { value: 3, label: '已发货',label1: '已发货' },
      { value: 6, label: '售后中',label1: '售后中' },
      { value: 5, label: '完成订单',
        label1:
          <div>
            完成订单
          <Tooltip
              align="t"
              trigger={
                <span
                  style={{
                    fontSize: '16px',
                    marginLeft: '4px',
                    cursor: 'pointer',
                  }}
                  className="iconfont icon-icon4-33"
                />
              }
            >
              1.在线支付订单，商家发货后，用户收货、拒收或者15天无物流更新；2.货到付款订单，用户确认收货
          </Tooltip>
        </div>
      },
      { value: 21, label: '退款成功' ,label1: '退款成功' },
      { value: 9, label: '已关闭',
        label1:
          <div>
            已关闭
            <Tooltip
                align="t"
                trigger={
                  <span
                    style={{
                      fontSize: '16px',
                      marginLeft: '4px',
                      cursor: 'pointer',
                    }}
                    className="iconfont icon-icon4-33"
                  />
                }
              >
                退款失败或退货失败
            </Tooltip>
          </div>
      },
      { value: 4, label: '已取消',
        label1:
        <div>
          已取消
          <Tooltip
              align="t"
              trigger={
                <span
                  style={{
                    fontSize: '16px',
                    marginLeft: '4px',
                    cursor: 'pointer',
                  }}
                  className="iconfont icon-icon4-33"
                />
              }
            >
              1.用户未支付时取消订单；2.用户超时未支付，系统自动取消订单；3.货到付款订单，用户拒收
          </Tooltip>
        </div>
      },
      // { value: "order_overtime", label: "超时未发货" }
    ];
    setOrderStatusDisc(getOrderStatusDisc);

    // 获取旗帜颜色字典 (废弃)
    // const getFlagColorsDisc = [
    //     { value: "flag_gray", label: "灰" },
    //     { value: "flag_purole", label: "紫" },
    //     { value: "flag_cyan", label: "青" },
    //     { value: "flag_green", label: "绿" },
    //     { value: "flag_orange", label: "橙" },
    //     { value: "flag_red", label: "红" }
    // ]
    // setFlagColorsDisc(getFlagColorsDisc);

    // 获取订单类型字典  (废弃)
    // const getOrderTypeDisc = [
    //     { value: "orderType_all", label: "全部" },
    //     { value: "orderType_lubanAd", label: "鲁班广告" },
    //     { value: "orderType_lianmeng", label: "联盟" },
    //     { value: "orderType_store", label: "商城" },
    //     { value: "orderType_zizhujingying", label: "自主经营" },
    //     { value: "orderType_form", label: "线索通支付表单" },
    //     { value: "orderType_douyinStore", label: "抖音门店" },
    //     { value: "orderType_dou+", label: "抖+" },
    //     { value: "orderType_chuanshanjia", label: "穿山甲" }
    // ]

    // setOrderTypeDisc(getOrderTypeDisc)

    // 获取APP渠道字典  (废弃)
    // const getAPPSourceDisc = [
    //     { value: "appSourch_all", label: "全部" },
    //     { value: "appSourch_outsideWeb", label: "站外" },
    //     { value: "appSourch_huoshan", label: "火山" },
    //     { value: "appSourch_douyin", label: "抖音" },
    //     { value: "appSourch_toutiao", label: "头条" },
    //     { value: "appSourch_xigua", label: "西瓜" },
    //     { value: "appSourch_wechat", label: "微信" },
    //     { value: "appSourch_sangou", label: "闪购" },
    //     { value: "appSourch_toutiaolite", label: "头条lite版本" },
    //     { value: "appSourch_dongchedi", label: "懂车帝" },
    //     { value: "appSourch_pipixia", label: "皮皮虾" },
    //     { value: "appSourch_douyinfast", label: "抖音极速版" },
    //     { value: "appSourch_TikTok", label: "TikTok" },
    // ]

    // setAPPSourceDisc(getAPPSourceDisc)

    // 获取订单来源字典  (废弃)
    // const getOrderSourceDisc = [
    //     { value: "orderSource_all", label: "全部" },
    //     { value: "orderSource_others", label: "其它" },
    //     { value: "orderSource_miniprogram", label: "小程序" },
    //     { value: "orderSource_h5", label: "H5" },
    //     { value: "orderSource_app", label: "app" }
    // ]

    // setOrderSourceDisc(getOrderSourceDisc);


    // 获取收货地区 字典
    Servlets('getCity', {}).then((res: { data: Array<{ provinceName: string; cityName: string; cityId: number; provinceId: number }> }) => {
      const cityAndProvinceArr = {};

      res.data.forEach((item) => {
        // 判断当前城市是否已找到应归属的省
        if (cityAndProvinceArr.hasOwnProperty(item.provinceName)) {
          cityAndProvinceArr[item.provinceName].children.push({ label: item.cityName, value: item.cityId });
        } else {
          cityAndProvinceArr[item.provinceName] = {
            children: [{
              label: item.cityName,
              value: item.cityId === item.provinceId ? `${item.cityId }city` : item.cityId,
            }],
            label: item.provinceName,
            value: item.provinceId,
          };
        }
      });

      setReceivingAreaDataDisc(Object.values(cityAndProvinceArr));
    });
  };
  /** 获取列表数据 */
  const getListData = (searchForm = { pageNo: 1, pageSize: pageInfo.pageSize, startCreateTime: '', endCreateTime: ''}): void => {
    setLoadingForList(true);
    if(searchForm.minPayAmount && searchForm.maxPayAmount && searchForm.maxPayAmount < searchForm.minPayAmount){
        LzMsg.error('实付金额最大值不应小于最小值');
        return false;
    }
    // 获取订单筛选列表数据
    Servlets('getOrdersList', { ...searchForm, ...{ pageNo: searchForm.pageNo } })
      .then((res: { data: []; page: { pageNo: number; pageSize: number; total: number } }) => {
        setLoadingForList(false);// 关闭loading

        setDataSource(res.data ? res.data : []); // 获取列表数据

        setPageInfo(res.page ? res.page : pageInfo);// 设置分页
      })
      .catch((err) => {
        console.log(err);
        setLoadingForList(false);
      });
  };

  /** 列表行选择事件触发 */
  const onRowChange = (selectedKeys: []): void => {
    if (!dataSource.length) return;
    setSelectedKeysList(selectedKeys);
  };

  /** 列表列过滤事件触发 */
  const onColumnFilter = (filterParams: object): void => {

  };
  /**
   * @description: 处理整个表单的搜索条件，查询及按结果创建营销活动时调用
   * @param {*} val 表单输入的所有值
   * @return {*} 通过此方法得到处理过后符合前后端约定的格式
   */
  const handleFormDataContent = (val) => {

    setSearchFormData(val);
    return {

      ...{
        orderId: val.orderId, // 订单编号
        postTel: val.postTel, // 收货人手机
        // orderMadeTime:val.orderMadeTime // 下单时间 （暂无）
        minPayAmount: val.minPayAmount, // 实付最小金额
        maxPayAmount: val.maxPayAmount, // 实付最大金额
        cityName: receivingAreaName.join(',') ?? '', // 收货地区
        orderStatus: currentTabKey,
      },
      ...{ // 时间区间处理
        startCreateTime: 
        val?.orderMadeTime ? moment(val?.orderMadeTime[0] * 1000).unix()
        : val.startCreateTime ? moment(val.startCreateTime * 1000).unix()
        : '', // 订单创建时间 起始
        endCreateTime:
        val?.orderMadeTime  ? moment(val?.orderMadeTime[1] * 1000).unix() 
        : val.endCreateTime ? moment(val.endCreateTime * 1000).unix()
        : '', // 订单创建时间 结束

        startCompletTime: val.completTime ? moment(val.completTime[0] * 1000).unix() : '', // 订单完成时间 起始
        endCompletTime: val.completTime ? moment(val.completTime[1] * 1000).unix() : '', // 订单完成时间 结束

        startPayTime: val.payTime ? moment(val.payTime[0] * 1000).unix() : '', // 订单付款时间 起始
        endPayTime: val.payTime ? moment(val.payTime[1] * 1000).unix() : '', // 订单付款时间 结束
      },
    };
  };

  /** 搜索表单提交时触发 */
  const handleSubmit = (val: any): void => {
    setCurrentTabKey(val.orderStatus?val.orderStatus:0);
    setSearchFormData(val);
    const searchForm = handleFormDataContent(val);
    // 订单状态,如果为0，也就是全部订单，就不传这个字段
    if (val.maxPayAmount<val.minPayAmount) {
      LzMessage.error('请输入正确的实付金额!')
    }else {
          if (val.orderStatus !== 0) {
            getListData({
              ...searchForm,
              orderStatus:val.orderStatus,
              ...{ // 分页
                pageNo: 1,
                pageSize: pageInfo.pageSize,
              },
            });
    }else if (val.orderStatus === 0){
            getListData({
              ...searchForm,
              ...{ // 分页
                orderStatus:'',
                pageNo: 1,
                pageSize: pageInfo.pageSize,
              },
            });
          }
    }

  };

  // 搜索表单重置时触发
  const handleReset = (): void => {
    setCurrentTabKey(0);
    setSearchFormData({orderStatus: 0, startCreateTime: moment().subtract(30, 'days').startOf('day'), endCreateTime: moment().endOf('day')});
    setReceivingAreaValue([]);
    setReceivingAreaName([]);
    getListData({orderStatus: '',startCreateTime: moment().subtract(30, 'days').startOf('day'), endCreateTime: moment().endOf('day')});
  };

  /** 列表数据格式配置项 */
  const getColumns = (): object[] => {
    // 列表数据格式配置项
    const columns = [
      // {
      //     title: "买家账号",
      //     dataIndex: "buyerAccount",
      //     width: 176,
      //     alignHeader: 'left',
      //     align: 'left'
      // },
      {
        title: '订单号',
        dataIndex: 'orderId',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        // cell: (value, index, record) => {
        //     return <div style={{ display: 'flex' }}>{value}<img src={icon_warning} alt="订单重要级" style={{ width: 14, height: 14, marginLeft: 4 }} /></div>
        // }
      },
      {
        title: '地区',
        dataIndex: 'receivingArea',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div style={{ userSelect: 'none' }}>
            {record.provinceName}{record.cityName}{record.townName}
                  </div>);
        },
      },
      {
        title: '订单状态',
        dataIndex: 'orderStatus',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (<div style={{ userSelect: 'none' }}>
            {
              orderStatusDiscAll[record.orderStatus]?.name ? orderStatusDiscAll[record.orderStatus].name : record.orderStatus
            }
          </div>);
        },
      },
      // {
      //     title: "下单时间",
      //     dataIndex: "orderMadeTime",
      //     width: 176,
      //     alignHeader: 'left',
      //     align: 'left'
      // },
      {
        title: '付款时间',
        dataIndex: 'payTime',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <div>{record.payTime != 0 ? moment(+record.payTime).format('YYYY-MM-DD HH:mm:ss') : '--'}</div>;
        },
      },
      {
        title: '订单完成时间',
        dataIndex: 'completTime',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <div>{record.completTime != 0 ? moment(+record.completTime).format('YYYY-MM-DD HH:mm:ss') : '--'}</div>;
        },
      },
      {
        title: '实付金额（不包含运费）',
        dataIndex: 'orderTotalAmount',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return <div>{(+record.orderTotalAmount / 100).toFixed(2)}</div>;
        },
      },
      // {
      //     title: "收货人手机号",
      //     dataIndex: "postTel",
      //     width: 176,
      //     alignHeader: 'left',
      //     align: 'left',
      //     cell: (value, index, record) => {
      //         return <div>{value.replace(/(\d{3})\d*(\d{4})/,'$1****$2')}</div>
      //     }
      // },
      // {
      //     title: "APP来源",
      //     dataIndex: "APPSource",
      //     width: 176,
      //     alignHeader: 'left',
      //     align: 'left',
      // },
      // {
      //     title: "订单来源",
      //     dataIndex: "orderSource",
      //     width: 176,
      //     alignHeader: 'left',
      //     align: 'left',
      // },
      // {
      //     title: "订单类型",
      //     dataIndex: "orderType",
      //     width: 176,
      //     alignHeader: 'left',
      //     align: 'left',
      // },
      {
        title: '操作',
        lock: 'right',
        width: 176,
        alignHeader: 'left',
        align: 'left',
        cell: (value, index, record) => {
          return (
          <div style={{ userSelect: 'none' }}>
            <Button
              type="primary"
              text
              onClick={() => window.open('https://fxg.jinritemai.com/index.html#/ffa/morder/order/list')}
            >查看
            </Button>
          </div>
          );
        },
      },
    ];
    return columns;
  };

  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = { pageNo: 1, pageSize: 10 }): Promise<void> => {

    const searchForm = handleFormDataContent(searchFormData);
    try {
      getListData({
        ...searchForm,
        orderStatus: currentTabKey === 0 ? '' : searchForm?.orderStatus,
        ...pages
      });
    } catch (e) {
      // LzMsg.error(e.message);
    }
  };

  /**  切换搜索表单是否展示全部搜索项 */
  const handleChangeAllFormShow = (): void => {
    setIsShowAllSearchForm(!isShowAllSearchForm);
  };
  /** 订单筛选tab - 清空列表已选 */
  const clearSelectedKeysList = (): void => {
    // 清空列表已选
    setSelectedKeysList([]);
  };
  /** 打开 新建订单筛选营销任务 弹窗 */
  const openCreateShortMesssageDialog = (type = ''): void => {
    const Params = {
      searchString: {},
      orderIdList: [] as string[],
      orderCrowdType: '',
      marketingType: '2',
      marketingTypeText: '订单筛选营销',
    };
    switch (type) {
      // 批量新建短信营销
      case 'batch':
        if (!selectedKeysList.length) {
          Message.notice('你还没有选择订单，请选择至少一个订单后操作');
          return;
        }
        const recipientKeys = [] as string[];
        dataSource.forEach((item) => {
          if (~selectedKeysList.indexOf(item.orderId)) {
            const recipientKey = item.postTel || item.orderId;
            if (!~recipientKeys.indexOf(recipientKey)) {
              recipientKeys.push(recipientKey);
              Params.orderIdList.push(String(item.orderId));
            }
          }
        });
        Params.orderCrowdType = '1'; // 1-手动选择 2-查询结果

        break;
      // 按查询结果新建短信营销
      case 'search':
        Params.searchString = handleFormDataContent({...searchFormData, orderStatus: searchFormData?.orderStatus === 0 ? '' : searchFormData?.orderStatus});
        Params.orderCrowdType = '2'; // 1-手动选择 2-查询结果
        break;

      default:
        break;
    }
    Params.peopleCrowdType = '0';

    // 将参数传递至仓库与缓存，若用户刷新页面时仓库数据被清空则使用缓存数据
    store.set('fromUrlToCreateMarket', '/Orderselection');// 标明数据源
    const record = {
      id: 1,
      name: '订单筛选人群',
      size: type === 'batch' ? selectedKeysList.length : pageInfo.total, // 如果是批量新建，就是取自己所选的条数，如果按查询结果，则直接取分页信息里的总数
      type: 0,
    };
    sessionStorage.setItem('LzCrowdMarket', JSON.stringify(record)); // 把当前人群内容存进缓存，到新建官方人群营销使用
    // console.log(Params.searchString,'父组件传的');
    store.set('sceneMarketingParams', Params);
    localStorage.setItem('sceneMarketingParams', JSON.stringify(Params));

    // 页面跳转新建短信营销页面
    appHistory.push('./orderSelection/createShortMesssage');
  };
  /** 由子组件调用，告知父组件，子组件弹窗是否已关闭 */
  // const changeOpenDiglog = (visible: boolean): void => {
  //     setOpenDiglog(visible);
  // }

  /** tabs 改变时触发 */
  const changeTabs = (tabKey): void => {
    const searchForm = handleFormDataContent(searchFormData);
    handleSubmit({
      ...searchForm,
      orderStatus: tabKey == 0 ? '' : +tabKey,
    })
    setCurrentTabKey(tabKey);
  };

  /**
   * 当用户点选地区时触发
   * @param value 当前已选的地区值
   * @param data 当前已选的地区详情对象 包括children数组
   * @param extra 当前已选的地区及children数组 组合的对象
   */
  const handleChangeCascader = (value: [], data: object[], extra) => {
    const selectedArea = [] as string[];
    const selectedName = [] as string[];

    extra.checkedData.forEach((res: { children: []; value: '' }) => {
      if (!res.children) {
        selectedArea.push(res.value);
        selectedName.push(res.label);
      }
    });

    selectedArea.unshift();
    setReceivingAreaValue(selectedArea);
    setReceivingAreaName(selectedName);
  };
  return (
    <>
      <div className={style.mainBox}>
        <div>
          <div className={style.orderSelectionList}>
            {/* 搜索表单 */}
            {/* <ParagraphTitle title='订单筛选与营销' subtitle="" /> */}
            <div attr-intro="搜索表单" className={style.listSearch}>
              <Form
                inline
                className={`${style.listSearchForm} form-orderSelection`}
                size="medium"
                value={searchFormData}
              >
                {isShowAllSearchForm &&
                (<FormItem label="订单编号:&emsp;&emsp;" className={style.formItem}>
                  <Input
                    name="orderId"
                    className={style.formItem_width}
                    placeholder="请输入..."
                    maxLength={100}
                    hasClear
                  />
                </FormItem>)}
                <FormItem label="下单时间:&emsp;&emsp;" className={style.formItem}>
                  <RangePicker
                    popupAlign="tl tl"
                    name="orderMadeTime"
                    placeholder="请点选..."
                    className={style.formItem_width}
                    followTrigger
                    disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                    showTime
                    defaultValue={[moment().subtract(30, 'days').startOf('day'), moment().endOf('day')]}
                  />
                </FormItem>
                {/*
                                {isShowAllSearchForm &&
                                    (<FormItem label="收货人手机:&emsp;" className={style.formItem}>
                                        <Input name="postTel" className={style.formItem_width} placeholder="请输入..." maxLength={11} hasClear />
                                    </FormItem>)} */}

                {/* {isShowAllSearchForm &&
                                    (<FormItem label="快递单号:" className={style.formItem}>
                                        <Input name="expressId" className={style.formItem_width} placeholder="请输入..." maxLength={100} hasClear />
                                    </FormItem>)} */}

                {/* {isShowAllSearchForm &&
                                    (<FormItem label="商品名称:" className={style.formItem}>
                                        <Input name="tradeName" className={style.formItem_width} placeholder="请输入..." maxLength={100} hasClear />
                                    </FormItem>)} */}

                {/* {isShowAllSearchForm &&
                                    (<FormItem label="&nbsp;&emsp;商品ID:" className={style.formItem}>
                                        <Input name="productId" className={style.formItem_width} placeholder="支持录入多个，已英文逗号分隔" maxLength={100} hasClear />
                                    </FormItem>)} */}

                {/* {isShowAllSearchForm &&
                                    (<FormItem label="旗帜颜色:" className={style.formItem}>
                                        <Select placeholder="请点选..." name="flagColors" className={style.formItem_width} hasClear dataSource={flagColorsDisc} followTrigger></Select>
                                    </FormItem>)} */}


                {/* {isShowAllSearchForm &&
                                    (<FormItem label="APP渠道:" className={style.formItem}>
                                        <Select placeholder="请点选..." name="appSource" className={style.formItem_width} hasClear dataSource={APPSourceDisc} followTrigger></Select>
                                    </FormItem>)} */}

                {/* 订单 */}

                <FormItem label="订单完成时间:" className={style.formItem}>
                  <RangePicker
                    popupAlign="tl tl"
                    name="completTime"
                    placeholder="请点选..."
                    className={style.formItem_width}
                    followTrigger
                    disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                    showTime
                  />
                </FormItem>
                <FormItem label="实付金额:&emsp;&emsp;" className={style.formItem}>
                  <NumberPicker
                    name="minPayAmount"
                    className={style.formItem_width_NumberPicker}
                    placeholder="最小..."
                    max={1000000}
                    min={0}
                    precision={2}
                    hasTrigger={false}
                  />
                  &emsp;-&emsp;
                  <NumberPicker
                    name="maxPayAmount"
                    className={style.formItem_width_NumberPicker}
                    placeholder="最大..."
                    max={1000000}
                    min={0}
                    precision={2}
                    hasTrigger={false}
                  />
                </FormItem>

                <FormItem label="订单状态:&emsp;&emsp;" className={style.formItem}>
                  <Select
                    placeholder="请点选..."
                    name="orderStatus"
                    className={style.formItem_width}
                    hasClear
                    dataSource={orderStatusDisc}
                    followTrigger
                  />
                </FormItem>

                {/* {isShowAllSearchForm &&
                                    (<FormItem label="订单类型:" className={style.formItem}>
                                        <Select placeholder="请点选..." name="orderType" className={style.formItem_width} hasClear dataSource={orderTypeDisc} followTrigger></Select>
                                    </FormItem>)} */}
                {/* <Input name="receivingArea" className={style.formItem_width} placeholder="支持录入多个，已英文逗号分隔" maxLength={100} hasClear /> */}
                {isShowAllSearchForm &&
                (<FormItem label="付款时间:&emsp;&emsp;" className={style.formItem}>
                  <RangePicker
                    popupAlign="tl tl"
                    name="payTime"
                    placeholder="请点选..."
                    className={style.formItem_width}
                    followTrigger
                    disabledDate={(date, view) => utils.disabledDate(date, view, 'back', false)}
                    showTime
                  />
                </FormItem>)}

                {isShowAllSearchForm &&
                (<FormItem label="收货地区:&emsp;&emsp;" className={`${style.formItem} setReceivingArea`}>
                  <Balloon
                    trigger={<Button
                      type="secondary"
                      className={style.formItem_width}
                    >请选择收货地区（已选择{receivingAreaValue.length}个地区）
                    </Button>}
                    triggerType="click"
                    popupStyle={{ maxWidth: 1500, minWidth: 150, opacity: 1 }}
                    followTrigger
                    className="test-Cascader"
                  >
                    <Cascader
                      multiple
                      checkStrictly={false}
                      value={receivingAreaValue}
                      dataSource={receivingAreaDataDisc}
                      onChange={handleChangeCascader}
                      listStyle={{ minWidth: 150 }}
                    />
                  </Balloon>
                </FormItem>)}
                {/* {isShowAllSearchForm &&
                      (<FormItem label="订单来源:" className={style.formItem}>
                          <Select placeholder="请点选..." name="orderSource" className={style.formItem_width} hasClear dataSource={orderSourceDisc} followTrigger></Select>
                      </FormItem>)} */}
                <FormItem
                  label=""
                  className={`${style.formItem} form-orderSelection-btn`}
                  style={{ textAlign: 'right' }}
                >
                  <Form.Submit
                    type="primary"
                    onClick={handleSubmit}
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                  >查询
                  </Form.Submit>
                  <Form.Reset
                    className={`${style.submitBtnStyle_width} ${style.submitBtnStyle_marginRight}`}
                    onClick={handleReset}
                  >重置
                  </Form.Reset>
                  <Button
                    iconSize={12}
                    style={{ fontSize: 12 }}
                    className={`${style.submitBtnStyle_width}`}
                    onClick={handleChangeAllFormShow}
                  >
                    <span>{isShowAllSearchForm ? '收起' : '展开'}&nbsp;</span><Icon
                      type="arrow-down"
                      style={{
                        transition: 'all .5s',
                        transform: `rotate(${isShowAllSearchForm ? '180' : '0'}deg)`,
                      }}
                    />
                  </Button>
                </FormItem>
              </Form>
            </div>
            <div className={style.childBox}>
              {/* 列表 */}
              <ParagraphTitle title="订单详情" subtitle="" />

              <Tab
                size="small"
                shape="text"
                animation
                navClassName={style.tabsStyle}
                onChange={(val)=>{changeTabs(val)
                }}
                activeKey={currentTabKey}
              >
                {
                  orderStatusDisc.map((item) => {
                    return (<Tab.Item title={item.label1} key={item.value}/>);
                  })
                }
              </Tab>
              <div style={{ padding: '20px' }}>
                <div className={style.listContent}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                  }}
                  >
                    <div className={style.formItem} style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ color: '#111' }}>已选择</span>
                      <span style={{ color: 'red' }}>&nbsp;{selectedKeysList.length}&nbsp;</span>
                      <span style={{ color: '#111' }}>项&emsp;</span>
                      <Button
                        type="primary"
                        text
                        onClick={clearSelectedKeysList}
                      >&nbsp;清空
                      </Button>
                    </div>
                    <div>
                      <Button
                        className={style.formItem}
                        type="primary"
                        style={{ marginRight: 6 }}
                        onClick={() => openCreateShortMesssageDialog('batch')}
                      > +&nbsp;批量新建短信营销
                      </Button>
                      <Button
                        className={style.formItem}
                        type="primary"
                        style={{ marginRight: 6 }}
                        onClick={() => { dataSource.length === 0 ? LzMessage.error('查询结果为空') : openCreateShortMesssageDialog('search')}}
                      >+&nbsp;按查询结果新建短信营销
                      </Button>
                      {/* <Button
                        className={style.formItem}
                        type="secondary"
                        style={{ marginRight: 6 }}
                        onClick={saveCrowd}
                      >批量存为人群包
                      </Button> */}
                    </div>
                  </div>
                  <div style={{ marginTop: 8 }}>
                    <Table
                      dataSource={dataSource}
                      fixedHeader
                      maxBodyHeight={460}
                      primaryKey="orderId"
                      rowSelection={{ selectedRowKeys: selectedKeysList, onChange: onRowChange }}
                      loading={isLoadingForList}
                      columns={columns}
                      onFilter={onColumnFilter}
                    >
                      {
                        columns.map((item: any, index: number) => {
                          return (
                            <Table.Column
                              title={item.title}
                              key={index}
                              dataIndex={item.dataIndex}
                              cell={item.cell}
                              align={item.align}
                              width={item.width}
                              alignHeader={item.alignHeader}
                              lock={item.lock}
                              htmlTitle={item.htmlTitle}
                            />
                          );
                        })
                      }
                    </Table>
                  </div>

                  {
                    !!dataSource.length && <div
                      attr-intro="分页组件"
                      className={[style.Pagination, 'Hjy-Pagination'].join(' ')}
                    >
                      <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
                    </div>
                  }

                </div>
              </div>
            </div>
          </div>

        </div>
        {/* pin上传复制dialog */}
        <Dialog
          title="复制人群"
          className="quickDialog_hjy" // hjy添加
          visible={crowdDialog}
          footer={
            <div>
              <Button
                type="normal"
                style={{ marginRight: '10px', marginLeft: '10px', width: 88 }}
                onClick={() => {
                  setCrowdDialog(false);
                  setRefreshParams(
                    {
                      description: `${moment().format('MM月DD日')}创建人群`,
                      name: `默认创建${moment().format('MM月DD日HH时mm分ss秒')}`
                    }
                  );
                }}
              >取消
              </Button>
              <Button
                type="primary"
                style={{ width: 88 }}
                onClick={() => {
                  packageRefreshSubmit();
                }}
              >确认
              </Button>
            </div>
          }
          height="332px"
          onClose={() => {
            setCrowdDialog(false);
            setRefreshParams({
              description: `${moment().format('MM月DD日')}创建人群`,
              name: `默认创建${moment().format('MM月DD日HH时mm分ss秒')}`
            });
          }}
        >
          <div style={{ width: '100%', height: '100%' }}>
            <div style={{ width: '100%', display: 'flex', marginTop: '20px', flexDirection: 'column' }}>
              <span
                style={{ lineHeight: '30px', fontFamily: 'PingFang SC Regular', color: '#000000' }}
              ><span
                style={{ color: 'red' }}
              >*
              </span>人群名称：
              </span>
              <Input
                onChange={(value) => {
                  setRefreshParams({ ...refreshParams, name: value });
                }}
                maxLength={32}
                value={refreshParams.name}
                hasLimitHint
                style={{ width: '100%', borderRadius: '2px' }}
              />
            </div>
            <div style={{ width: '100%', display: 'flex', marginTop: '20px', flexDirection: 'column' }}>
              <span
                style={{ lineHeight: '30px', fontFamily: 'PingFang SC Regular', color: '#000000' }}
              >
              </span>人群描述：
              <Input
                onChange={(value) => {
                  setRefreshParams({ ...refreshParams, description: value });
                }}
                maxLength={32}
                value={refreshParams.description}
                hasLimitHint
                aria-label="Medium"
                style={{ width: '100%', borderRadius: '2px' }}
              />
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};


export default Tabs_orderSelection;
